import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import { createStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material';
import { BrowserRouter } from 'react-router-dom';
import reducer from './stores/globalStore';
import { themeOptions } from './utils/Theme';
import App from './components/App/App';
import './i18n';

const store = createStore(reducer);

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={themeOptions}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </Provider>,
  document.getElementById('root')
);

// TODO voir pour la font qui vient de google
